import React, { useState } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import useAppContext from 'flow/hooks/useAppContext';
import {
    getCtiSetting,
    setCtiSetting,
    CTI_SETTINGS_SHOW_ON_LOAD_MODE,
} from 'flow/utils/cti-settings-utils';
import { addCtiLogEntry } from 'flow/utils/browser-utils';
import { ExtensionKey } from 'flow/types/EntityKeys';

import { routes } from 'flow/types/routes';
import Page from 'flow/components/Setting/Page';
import RadioButton from 'flow/components/ui-components/RadioButton';
import Divider from 'flow/components/ui-components/Divider';
import { generatePath } from 'flow/utils/router-utils';

const ShowOnLoad = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    const settings = useAppSelector(getCtiSetting);

    const [selectedOption, setSelectedOption] = useState(
        settings.showOnLoad.value,
    );

    const updateSetting = (uniqueId: string) => {
        setSelectedOption(uniqueId);
        addCtiLogEntry(`setting showOnLoad was changed to ${uniqueId}`);
        setCtiSetting({ ...settings, showOnLoad: { value: uniqueId } });
    };

    const getOption = (option: string, translation: string) => (
        <RadioButton
            checked={selectedOption === option}
            name={option}
            onChange={() => updateSetting(option)}
        >
            {i18next.t(translation)}
        </RadioButton>
    );

    return (
        <Page
            header={i18next.t('settings.cti.enable.show.on.load')}
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.cti-settings'], {
                        extensionKey,
                    }),
                )
            }
        >
            {getOption(
                CTI_SETTINGS_SHOW_ON_LOAD_MODE.SHOW,
                'settings.cti.enable.show.on.load',
            )}

            {getOption(
                CTI_SETTINGS_SHOW_ON_LOAD_MODE.HIDDEN,
                'settings.cti.disable.show.on.load',
            )}

            {getOption(
                CTI_SETTINGS_SHOW_ON_LOAD_MODE.USER_LOGGED_IN,
                'settings.cti.enable.show.on.login',
            )}
            <Divider />
        </Page>
    );
};

export default ShowOnLoad;
